import { sendBatch } from "./sendBatch"

const metabase = { sendBatch }

export default metabase
